/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyResponsePaging } from '../../models/company-response-paging';

export interface GetCompanies$Params {
  searchFilter: string;
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getCompanies(http: HttpClient, rootUrl: string, params: GetCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getCompanies.PATH, 'get');
  if (params) {
    rb.query('searchFilter', params.searchFilter, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyResponsePaging>;
    })
  );
}

getCompanies.PATH = '/api/companies';
